import React, { useEffect } from "react";
import "./privacy-policy.css";

const Shipping_Policy = () => {
  // 🔴 ADDED: PAGE HAMESHA TOP SE OPEN HOGA
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "instant", // smooth chahiye to "smooth"
    });
  }, []);
  return (
    <div className="privacy-wrapper">
      <div className="privacy-card">
        <h2 className="privacy-title">Shipping Policy :</h2>

        <p>
          a. <strong>Shipping Methods:</strong> We partner with trusted
          third-party service providers to ensure safe and efficient delivery of
          your orders. Our shipping methods may include standard and expedited
          options, depending on your location and preferences.
        </p>

        <p>
          b. <strong>Shipping Charges:</strong> Shipping charges are calculated
          based on factors such as destination, order weight, and the selected
          shipping method. The applicable shipping charges will be displayed
          during the checkout process before finalizing the purchase.
        </p>

        <p>
          c. <strong>Tracking Orders:</strong> To ensure transparency and peace
          of mind, we provide order tracking for all shipments. Once the order
          is processed and shipped, customers will receive a tracking number
          along with instructions to monitor the delivery status in real time.
        </p>

        <h2 className="privacy-title">Delivery of UJALA Products :</h2>

        <p>
          a. The waiting period and the expected delivery date shall be
          communicated by the system or the Authorized UJALA Dealer at the time
          of booking.
        </p>

        <p className="privacy-footer">
          b. The Customer is required to follow the cancellation and refund
          procedure as mentioned herein.
        </p>
      </div>
    </div>
  );
};

export default Shipping_Policy;
